import { TaxType } from "application-types";
import { isNumberThreeDecimalPlaces, isNumberTwoDecimalPlaces } from "./isNumberTwoDecimalPlaces";

export function isTaxValueValid(tax: TaxType | undefined): boolean {
  if (!tax) {
    return true;
  }

  if (tax.value === '' || tax.value === undefined) {
    return false;
  }

  const numValue = Number(tax.value);

  if (numValue < 0) {
    return false;
  }

  if (tax.type === "TAX_AMOUNT_TYPE_PERCENTAGE") {
    return isNumberThreeDecimalPlaces(parseFloat(tax.value));
  }

  if (tax.type === "TAX_AMOUNT_TYPE_FIXED") {
    return isNumberTwoDecimalPlaces(parseFloat(tax.value));
  }

  return false;
}
